import {
  HeadingGroup,
  ModalLayout,
} from "@wac-ui-dashboard/wac_component_library";
import useShippingPolicy from "./useShippingPolicy";
import EditPolicy from "./EditPolicy";
import Style from './shippingPolicy.module.scss';

const ShippingPolicy = () => {
  const { mainData, menuState, closeModal, refetch, handleEditClick } =
  useShippingPolicy();

  const parse = require("html-react-parser");
  const content = mainData?.data?.result?.description ?? "";

  return (
    <>
      {/* <h3>Privacy Policy</h3> */}
      {/* < onClick={handleEditClick}>{parse(content)}<span className="material-symbols-outlined">
              edit_square
            </span></> */}

      <HeadingGroup title={"Shipping Policy"} extraClassName={`pro-mb-5`}>
        <button
          className="pro-btn pro-btn-primary pro-items-center"
          onClick={handleEditClick}
        >
          <span class="material-symbols-outlined">edit_square</span>
          <span>Edit</span>
        </button>
      </HeadingGroup>

      <div className={`pro-pb-5 ${Style.admin_content_area}`}>
        {parse(content)}
      </div >

      <ModalLayout
        centered={false}
        show={menuState.showEditModal}
        handleClose={() => closeModal()}
        title={menuState?.is_edit ? "Update Shipping Policy" : ""}
        closeIcon={<span className="material-symbols-outlined">close</span>}
        backdrop="static"
        propStyle ={{root: Style.modal_root}}
      >
        <EditPolicy closeModal={() => closeModal()} refetch={refetch} />
      </ModalLayout>
    </>
  );
};

export default ShippingPolicy;
